<template>
    <div class="subfooter">
        <div class="container">
            <div class="row">
                <div class="col-md-6 col-sm-6">
                    <div class="copyrights">
                        Copyright 2017  <router-link to="/">Hotel CEO Group</router-link> Todos los derechos reservados.
                    </div>
                </div>
                <div class="col-md-6 col-sm-6">
                    <div class="social_media">
                        <social-item  type="facebook" ></social-item>
                        <social-item  type="twitter" ></social-item>
                        <social-item  type="googleplus" ></social-item>
                        <social-item  type="pinterest" ></social-item>
                        <social-item  type="linkedin" ></social-item>
                        <social-item  type="instagram" ></social-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import socialItem from './SocialItem.vue';
    export default {
        components : {
            'social-item' : socialItem
        },
    }
</script>


// WEBPACK FOOTER //
// Subfooter.vue?436e4f25